export default __webpack_public_path__ + "static/media/companyLogo.6d6110d6.png";